// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3MpuF","author":"Table_author__3Uibo","authorImage":"Table_authorImage__hOx1l","unreadRow":"Table_unreadRow__1cwOe"};